<header mat-dialog-title class="u-flex-full">
  <span>
    {{'risks.Seleziona obiettivo' | translate}}
  </span>
</header>
<mat-dialog-content>
  <target-list [targets]="targets" [defaultFilters]="defaultFilters" [displayedColumns]="displayedColumns" [total]="total"
    [canSelect]="true" (onSortChange)="sortChange($event)" (onPageChange)="pageChange($event)"
    (onFilterChange)="filtersChange($event)" (onSelectTarget)="selectTarget($event)"></target-list>
</mat-dialog-content>
<mat-dialog-actions class="u-flex-full">
  <span>
  </span>
  <button mat-raised-button color="basic" type="button" (click)="close()">{{'shared.Chiudi' | translate}}</button>
</mat-dialog-actions>
